import { ICoordinate, IGeoJSON } from "./common.models";

/** A single area polygon currently rendered on the stations map, with its assigned route-palette color. */
export interface IShownAreaPolygon {
  areaId: number;
  areaName: string;
  value: IGeoJSON;
  colorId: number;
  colorValue: string;
}

/** Which station selection a bulk action should target on the stations map. */
export enum StationsBulkActionSourceEnum {
  checkbox = "checkbox",
  markers = "markers",
}

/** The chosen bulk-action target on the stations map: a source plus the resolved station ids. */
export interface IStationsBulkActionTarget {
  source: StationsBulkActionSourceEnum;
  stationIds: number[];
}

/** The shape every MapLibre line source takes: a GeoJSON LineString wrapped in a Feature. */
export type TLineStringFeature = GeoJSON.Feature<GeoJSON.LineString>;

/**
 * Coordinate tuples. The two orders are NOT interchangeable: tracking render-state data and every
 * geometry helper in the app are `[lat, lng]`, while GeoJSON and every MapLibre API are `[lng, lat]`.
 *
 * `TLatLngTuple` and `TLatLngExpression` replace Leaflet's `LatLngTuple` and `LatLngExpression`, which
 * the app leaned on long after it stopped rendering with Leaflet — they were ambient globals from
 * `@types/leaflet`, so most files using them never imported it and nothing flagged the dependency.
 */

/** `[lat, lng]` — render-state order. */
export type TLatLngTuple = [number, number];

/** `[lng, lat]` — GeoJSON / MapLibre order. */
export type TLngLatTuple = [number, number];

/** A position: the `[lat, lng]` tuple, or the `{ lat, lng }` object form. */
export type TLatLngExpression = TLatLngTuple | ICoordinate;

/** `[x, y]` in pixels — a screen offset or padding. */
export type TPointTuple = [number, number];
